import {
  Routes,
  TitleStrategy,
  provideRouter,
  withComponentInputBinding,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
} from "@angular/router";
import { provideZonelessChangeDetection, inject, provideEnvironmentInitializer } from "@angular/core";
import { provideHttpClient, withFetch } from "@angular/common/http";
import { appInitGapi, RefreshGapiTokenService } from "@dis/auth";
import { provideFirebase } from "./firebase/firebase.config";
import { environment } from "../../environments/environment";

import { GAPIService } from "@dis/gapi";
import { provideNgxsCore } from "./ngxs/ngxs.core";
import { provideMaterialCore } from "./material/material.core";
import { DATE_PIPE_DEFAULT_OPTIONS } from "@angular/common";
import { provideTanstack } from "./tanstack/tanstack.config";
import { JtmsTitleStrategy } from "./routing/jtms-title.strategy";

export interface CoreOptions {
  routes: Routes;
}

export function provideCore({ routes }: CoreOptions) {
  return [
    provideZonelessChangeDetection(),
    provideHttpClient(withFetch()),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withEnabledBlockingInitialNavigation(),
      withInMemoryScrolling({
        anchorScrolling: "enabled",
        scrollPositionRestoration: "enabled",
      })
    ),
    { provide: TitleStrategy, useClass: JtmsTitleStrategy },

    // other 3rd party libraries providers like NgRx, provideStore()
    provideFirebase(environment),
    provideTanstack(environment),
    provideNgxsCore(),
    provideMaterialCore(),

    // other application specific providers and setup

    // perform initialization, has to be last
    provideEnvironmentInitializer(() => {
      const initializerFn = appInitGapi(inject(GAPIService), inject(RefreshGapiTokenService));
      return initializerFn();
    }),
    // App wide format providers
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { dateFormat: "EEE, MMM d y" } },
  ];
}
